import { render, staticRenderFns } from "./muokkaa-poissaoloa.vue?vue&type=template&id=6932dd08&scoped=true&"
import script from "./muokkaa-poissaoloa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-poissaoloa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-poissaoloa.vue?vue&type=style&index=0&id=6932dd08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6932dd08",
  null
  
)

export default component.exports